module.exports = __webpack_public_path__ + "img/admiral.69164ef8.png";